module.exports = "/assets/data/7c10f878a655ed69f1fbe77fd68251ce-BS20.data.json";